import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuxService {
  slugify(text: string): string {
    return text
      .toLowerCase() // deixa minúsculo
      .normalize('NFD') // separa os acentos dos caracteres
      .replace(/[\u0300-\u036f]/g, '') // remove os acentos
      .replace(/[^a-z0-9 ]/g, '') // remove caracteres que não sejam letras, números ou espaço
      .trim() // remove espaços no início e fim
      .replace(/\s+/g, '-'); // substitui espaços por hífen
  }
}
